import {TOGGLE_TOP_NAV, TOGGLE_TOP_NAV_BREAKPOINT} from '../actionTypes';


export function toggleSidebar(flag) {
	return {
		type: TOGGLE_TOP_NAV,
		flag
	}
}

export function setSidebarBreakpoint(flag) {
	return {
		type: TOGGLE_TOP_NAV_BREAKPOINT,
		flag
	}
}